import type { TagProps } from "@chakra-ui/react"
import { FormattedMessage } from "react-intl"

import {
  SharedDataStatusTag,
  getSharedDataStatusDisplay,
} from "@/components/DomainTag/SharedDataStatusTag/SharedDataStatusTag"
import { Tag } from "@/components/Tag"

import { getInterBuStatusColors } from "./interbuStatusPalette"

type Props = { status?: string; isTinted?: boolean } & TagProps

// Status of an InterBU share in the DS InterBU palette: coloured dot, word in the status ink, and
// with isTinted the soft ground of the status (cards). The word always stays: colour never carries
// the meaning alone. A status outside the palette (archive) keeps the plain status tag.
export const InterBUStatusTag: React.FC<Props> = ({ status, isTinted = false, ...props }) => {
  const colors = getInterBuStatusColors(status)
  if (!colors) {
    return <SharedDataStatusTag status={status} {...props} />
  }

  return (
    <Tag
      variant="status"
      color={colors.ink}
      // The whole dot of the "status" variant, in the status colour (a partial _before could
      // replace the theme's instead of extending it).
      _before={{
        content: '""',
        flex: "none",
        w: "9px",
        h: "9px",
        borderRadius: "full",
        bg: colors.fill,
        boxShadow: "none",
      }}
      {...(isTinted && { bg: colors.tint, px: "3", py: "2", borderRadius: "sm" })}
      data-status={status}
      {...props}
    >
      <FormattedMessage id={getSharedDataStatusDisplay(status).messageId} />
    </Tag>
  )
}
